import React from 'react';
import ApartmentIcon from '@mui/icons-material/Apartment';
import CategoryIcon from '@mui/icons-material/Category';
import PublicIcon from '@mui/icons-material/Public';
import StorageIcon from '@mui/icons-material/Storage';
import { RailShell, RailGroup, RailFact, RailGatingHint } from '../../../components/common/SummaryRailParts';

// At-a-glance panel for the group-edit wizard: the group facts plus the save-gating hint.
export default function SummaryRail({ values = {}, blocked = false }) {
  return (
    <RailShell>
      <RailGroup title="Group" first>
        <RailFact icon={<ApartmentIcon />} label="Name" value={values.name} />
        <RailFact icon={<CategoryIcon />} label="Type" value={values.groupType} />
        <RailFact icon={<PublicIcon />} label="Country" value={values.country} />
        <RailFact icon={<StorageIcon />} label="Storage" value={values.dataStorageLocation} />
      </RailGroup>

      <RailGatingHint blocked={blocked} message="A group with this name already exists — resolve it before saving." />
    </RailShell>
  );
}
